"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakeRewardStatus = exports.StakeType = void 0;
/**
 * Stake Type.
 */
var StakeType;
(function (StakeType) {
    StakeType["STATIC"] = "static";
    StakeType["DYNAMIC"] = "dynamic";
})(StakeType = exports.StakeType || (exports.StakeType = {}));
/**
 * Stake reward status.
 */
var StakeRewardStatus;
(function (StakeRewardStatus) {
    StakeRewardStatus["UNPROCESSED"] = "unprocessed";
    StakeRewardStatus["PROCESSED"] = "processed";
    StakeRewardStatus["PROCESSED_NO_STAKES"] = "processed_no_stakes";
    StakeRewardStatus["ERROR"] = "error";
    StakeRewardStatus["DELETED"] = "deleted";
})(StakeRewardStatus = exports.StakeRewardStatus || (exports.StakeRewardStatus = {}));
